import axios from "axios";
import { Suggestion } from "../../../../interfaces/Commission/types";



export const fetchBmsModel = async (
    search: string
): Promise<Suggestion[]> => {
    const { data } = await axios.get(
        `${process.env.REACT_APP_DJANGO_SERVER_URL}/api/staff/v1/accumulator_bms_model/list`,
        {
            params: { search },
            withCredentials: true,
        }
    );

    return data.results.map((item: any) => ({
        id: item.id,
        name: item.name,
    }));
};


export const fetchAdditionalEquipment = async (
    search: string
): Promise<Suggestion[]> => {
    const { data } = await axios.get(
        `${process.env.REACT_APP_DJANGO_SERVER_URL}/api/staff/v1/accumulator_additional_equipment/list`,
        {
            params: { search },
            withCredentials: true,
        }
    );

    return data.results.map((item: any) => ({
        id: item.id,
        name: item.name,
    }));
};


export const fetchDischargeConnectors = async (
    search: string
): Promise<Suggestion[]> => {
    const { data } = await axios.get(
        `${process.env.REACT_APP_DJANGO_SERVER_URL}/api/staff/v1/accumulator_discharge_connector/list`,
        {
            params: { search },
            withCredentials: true,
        }
    );

    return data.results.map((item: any) => ({
        id: item.id,
        name: item.name,
    }));
};


export const fetchChargeConnectors = async (
    search: string
): Promise<Suggestion[]> => {
    const { data } = await axios.get(
        `${process.env.REACT_APP_DJANGO_SERVER_URL}/api/staff/v1/accumulator_charge_connector/list`,
        {
            params: { search },
            withCredentials: true,
        }
    );

    return data.results.map((item: any) => ({
        id: item.id,
        name: item.name,
    }));
};


export const fetchCurrentSensors = async (
    search: string
): Promise<Suggestion[]> => {
    const { data } = await axios.get(
        `${process.env.REACT_APP_DJANGO_SERVER_URL}/api/staff/v1/accumulator_current_sensor/list`,
        {
            params: { search },
            withCredentials: true,
        }
    );

    return data.results.map((item: any) => ({
        id: item.id,
        name: item.name,
    }));
};


export const fetchExternalRemoteControls = async (
    search: string
): Promise<Suggestion[]> => {
    const { data } = await axios.get(
        `${process.env.REACT_APP_DJANGO_SERVER_URL}/api/staff/v1/accumulator_external_remote_control/list`,
        {
            params: { search },
            withCredentials: true,
        }
    );

    return data.results.map((item: any) => ({
        id: item.id,
        name: item.name,
    }));
};